import { useMemo } from "react"

import { useGetRuntimeCoverage } from "@/api/useInventory"
import { useFeatureFlags } from "./useUser"

export const useRuntimeCoverage = () => {
  const kortexInstalled = useFeatureFlags("kortexInstalled")
  const context = useGetRuntimeCoverage(
    {},
    { staleTime: Infinity, enabled: kortexInstalled === true }
  )
  const { isFetched } = context

  const isLowRuntimeCoverage = useMemo(() => {
    if (kortexInstalled === false) return false
    if (kortexInstalled === undefined || !isFetched) return undefined

    return context.response?.data?.isLowRuntimeCoverage ?? false

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kortexInstalled, isFetched])

  return { isFetched, isLowRuntimeCoverage }
}
